import { CommonModule } from '@angular/common';
import { Component, computed, effect, inject } from '@angular/core';
import { I18nService } from '../../../../core/i18n';
import { CompanyContextService } from '../../../../core/tenant/company-context.service';
import { AppModalComponent } from '../../../../shared/ui/modal/app-modal.component';
import { ToastService } from '../../../../shared/ui/toast/toast.service';
import { OnboardingStore } from '../../stores/onboarding.store';
import { OnboardingStepInviteComponent } from './step-invite.component';
import { OnboardingStepTemplateComponent } from './step-template.component';
import { OnboardingStepWelcomeComponent } from './step-welcome.component';
import { OnboardingStepWhatsappComponent } from './step-whatsapp.component';

@Component({
  selector: 'app-onboarding-tour',
  standalone: true,
  imports: [
    CommonModule,
    AppModalComponent,
    OnboardingStepWelcomeComponent,
    OnboardingStepTemplateComponent,
    OnboardingStepInviteComponent,
    OnboardingStepWhatsappComponent,
  ],
  template: `
    <app-modal
      [visible]="store.visible()"
      [closeOnOverlay]="false"
      [closeOnEscape]="false"
      [showCloseButton]="false"
      [size]="size()"
      [shrinkWrapBody]="false"
    >
      <div modalBody>
        @switch (store.currentStep()) {
          @case (1) {
            <app-onboarding-step-welcome></app-onboarding-step-welcome>
          }
          @case (2) {
            <app-onboarding-step-template></app-onboarding-step-template>
          }
          @case (3) {
            <app-onboarding-step-invite></app-onboarding-step-invite>
          }
          @case (4) {
            <app-onboarding-step-whatsapp></app-onboarding-step-whatsapp>
          }
        }
      </div>
    </app-modal>
  `,
})
export class OnboardingTourComponent {
  protected readonly store = inject(OnboardingStore);
  private readonly companyContext = inject(CompanyContextService);
  private readonly toast = inject(ToastService);
  private readonly i18n = inject(I18nService);

  protected readonly size = computed(() => (this.store.currentStep() === 2 ? 'lg' : 'md'));

  constructor() {
    let lastSeenStep: number | null = null;

    // Trigger unico: effect cobre montagem inicial + troca de empresa.
    // (Sem chamar loadStatus() em ngOnInit pra evitar dupla execucao.)
    effect(() => {
      const key = this.companyContext.activeCompanyKey();
      if (!key) return;
      void this.store.loadStatus();
    });

    // Toast final quando o tour acabou de concluir (transicao step<4 -> step=4 com tour visivel agora false).
    effect(() => {
      const status = this.store.status();
      if (!status) {
        lastSeenStep = null;
        return;
      }
      const prev = lastSeenStep;
      lastSeenStep = status.step;
      if (prev !== null && prev < 4 && status.step === 4 && !status.shouldShowTour) {
        this.toast.success(this.i18n.t('onboarding.toastfinish'));
      }
    });
  }
}
